import { ErrorMessage } from "formik";

import { useFieldError } from "@/hooks";

const ValidationMessage = (props) => {
  const { name } = props;

  const hasError = useFieldError(name);

  const renderMessage = (message) =>
    typeof message === "string" ? message : Object.values(message)[0];

  if (!hasError) return null;

  return (
    <ErrorMessage name={name}>
      {(message) => (
        <span className="mt-[0.625rem] text-sm font-normal leading-[0.813rem] text-red-500">
          {renderMessage(message)}
        </span>
      )}
    </ErrorMessage>
  );
};
export { ValidationMessage };
